<div class="header">
  <div class="header__logo-container">
    <a class="hidden sm:inline" routerLink="/" (click)="trackHomePageNavigation()">
      <img class="header__logo" alt="App Logo" [src]="'app_header_logo.png' | mpThemeAssetsPath | async" />
    </a>

    <!-- On low resolution in place of logo we display toggle sidenav button to make it accessible -->
    <button mat-icon-button (click)="toggleSidenav()" class="toggle-sidenav-button sm:!hidden">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <div class="header-elements">
    @for (placement of headerElementPlacements; track $index) {
      <div class="header-elements__element" [class]="{ 'header-elements__element--center': placement === 'center' }">
        @let placementElements = headerElementsMap()[placement];

        @for (elementTemplate of placementElements; track $index) {
          <ng-container *ngTemplateOutlet="elementTemplate; context: { $implicit: activeRouteTitle() }" />
        }
      </div>
    }
  </div>
</div>
